<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :title="template !== null ? $t('edit_template') : ''"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @closed="$refs.editTemplate.resetFields()">
    <el-form
      label-position="top"
      :model="form"
      :rules="rules"
      ref="editTemplate"
      :disabled="loading">
        <el-form-item
          prop="text"
          :label="$t('text')">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 10}"
            resize="none"
            v-model="form.text"
            class="rtl text-right"/>
        </el-form-item>
      <div class="line"></div>
      <el-form-item class="no-margin">
        <el-button
         @click="validateAndSubmitForm('editTemplate', updateTemplate)"
         :loading="loading" type="primary">
          {{ $t('submit') }}
        </el-button>
        <el-button
         @click="$emit('close-clicked')"
         :loading="loading">
          {{ $t('close') }}
        </el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    template: {
      type: Object,
      default: () => []
    }
  },
  data () {
    return {
      loading: false,
      form: {
        text: ''
      },
      rules: {
        text: [{
          required: true,
          message: this.$i18n.t('field_required')
        }]
      }
    }
  },
  computed: {
    ...mapGetters([
      'domainsPath'
    ])
  },
  methods: {
    ...mapActions([
      'handleRequest'
    ]),
    toggleLoading () {
      this.loading = !this.loading
    },
    handleUpdateTemplateSuccess (template) {
      this.$emit('template-updated', template)
      this.displaySuccessMsg('edit_template')
      this.toggleLoading()
      this.handleClose()
    },
    updateTemplate () {
      const { form, template } = this
      const { domainsPath } = this
      const { text } = form
      const { name, flavor, language } = template
      const toUpdate = {
        name,
        text,
        flavor,
        language
      }
      this.toggleLoading()
      this.handleRequest({
        name: `${domainsPath}/templates/${template.id.numberStr}`,
        action: 'update',
        data: {
          toUpdate
        }
      }).then(this.handleUpdateTemplateSuccess)
        .catch(this.toggleLoading)
    },
    setEditTemplateForm () {
      const { template, form } = this
      this.loading = false
      form['text'] = template.text
    }
  },
  watch: {
    template () {
      this.setEditTemplateForm()
    }
  }
}
</script>
